import { ComponentType } from 'react'
import { useTranslation } from 'react-i18next'
import { GridIcon, BadgeIcon, WaveformIcon, MessageIcon, PhoneIcon } from '@honestica/curecall-ui'
import { twMerge } from 'src/utils/tw-merge.util'
import { EHumanReviewTab, THumanReviewTab } from './human-review-requests.type'

const TAB_ICONS: Record<EHumanReviewTab, ComponentType<{ className?: string }>> = {
  [EHumanReviewTab.ALL]: GridIcon,
  [EHumanReviewTab.ADMINISTRATIVE_DOCUMENTS]: BadgeIcon,
  [EHumanReviewTab.MEDICAL_DOCUMENTS]: WaveformIcon,
  [EHumanReviewTab.CONVOCATION]: MessageIcon,
  [EHumanReviewTab.POST_OP_CONTROL]: PhoneIcon,
}

const TAB_LABELS: Record<EHumanReviewTab, string> = {
  [EHumanReviewTab.ALL]: 'pages.dashboard.human-review-requests.tabs.all',
  [EHumanReviewTab.ADMINISTRATIVE_DOCUMENTS]:
    'pages.dashboard.human-review-requests.tabs.administrative-documents',
  [EHumanReviewTab.MEDICAL_DOCUMENTS]: 'pages.dashboard.human-review-requests.tabs.medical-documents',
  [EHumanReviewTab.CONVOCATION]: 'pages.dashboard.human-review-requests.tabs.convocation',
  [EHumanReviewTab.POST_OP_CONTROL]: 'pages.dashboard.human-review-requests.tabs.post-op-control',
}

type Props = {
  tabs: THumanReviewTab[]
  activeTab: EHumanReviewTab
  onTabChange: (tab: EHumanReviewTab) => void
}

const HumanReviewTabs = ({ tabs, activeTab, onTabChange }: Props) => {
  const { t } = useTranslation()

  return (
    <div className="c-flex c-gap-2 c-flex-wrap c-mt-2">
      {tabs.map((tab) => {
        const Icon = TAB_ICONS[tab.subject]
        return (
          <button
            key={tab.subject}
            onClick={() => onTabChange(tab.subject)}
            className={twMerge(
              'c-flex c-items-center c-gap-2 c-px-3 c-py-1 c-rounded-lg c-border c-text-sm c-font-medium c-transition-colors c-group',
              activeTab === tab.subject
                ? 'c-bg-primary-600 c-text-white c-border-primary-600'
                : 'c-bg-white c-border-grey-500 hover:c-border-primary-600 hover:c-bg-primary-100 hover:c-text-primary-700',
            )}
          >
            <Icon className="c-w-4 c-h-4" />
            {t(TAB_LABELS[tab.subject])}
            <span
              className={twMerge(
                'c-inline-flex c-items-center c-justify-center c-text-xs c-font-semibold c-rounded-full c-min-w-[22px] c-h-[22px] c-px-1.5 c-bg-primary-200',
                activeTab === tab.subject
                  ? 'c-text-primary-700'
                  : 'c-text-primary-600 group-hover:c-bg-primary-300',
              )}
            >
              {tab.toProcessCount}
            </span>
          </button>
        )
      })}
    </div>
  )
}

export default HumanReviewTabs
